import "./UpCurve.style.scss";
import { ReactComponent as Curve } from "./../../images/svg/edgeCurv-Up.svg";

const UpCurve = () => <Curve className="up-curv" />;

export default UpCurve;
